import { render, staticRenderFns } from "./comunicados.vue?vue&type=template&id=31264496&"
import script from "./comunicados.vue?vue&type=script&lang=js&"
export * from "./comunicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports